import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFurrynetworkComponent } from './simple-icons-furrynetwork.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFurrynetworkComponent ],
    exports:      [ SimpleIconsFurrynetworkComponent ],
    bootstrap:    []
})
export class SimpleIconsFurrynetworkModule {}
